export var MolstarTools;
(function (MolstarTools) {
    function getModelIdFromTrajectory(trajectory) {
        var _a, _b;
        return (_b = (_a = trajectory.structure) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data.units[0].model.id;
    }
    MolstarTools.getModelIdFromTrajectory = getModelIdFromTrajectory;
})(MolstarTools || (MolstarTools = {}));
